import type { ReviewEntryQuestion } from '../../../../../types/reviewEntryQuestion'
import { excludeThirdPartyQuestions } from '../../../../../utils/reviewEntryThirdPartyQuestion'

const getQuestionText = (question: ReviewEntryQuestion): string | undefined =>
  question.content?.trim() || question.message?.trim()

export const getClarificationQuestions = (questions: ReviewEntryQuestion[]): ReviewEntryQuestion[] =>
  excludeThirdPartyQuestions(questions).filter((question) => Boolean(getQuestionText(question)))
